import { useState, useEffect } from "react";

interface TypewriterProps {
    text: string;
    speed?: number; // Typing speed in milliseconds
    loop?: boolean; // Whether the typewriter should loop
  }
  
  const Typewriter: React.FC<TypewriterProps> = ({ text, speed = 100, loop = false }) => {
    const [displayedText, setDisplayedText] = useState<string>("");
    const [index, setIndex] = useState<number>(0);
  
    useEffect(() => {
      if (index < text.length) {
        const timeout = setTimeout(() => {
          setDisplayedText((prev) => prev + text[index]);
          setIndex(index + 1);
        }, speed);
        return () => clearTimeout(timeout);
      } else if (loop) {
        const timeout = setTimeout(() => {
          setDisplayedText("");
          setIndex(0);
        }, 2000); // Delay before looping
        return () => clearTimeout(timeout);
      }
    }, [index, text, speed, loop]);
  
    return <span>{displayedText}{index < text.length ? "|" : ""}</span>;
  };
  
  export default Typewriter;